
export default {
  props: ['league'],
  components: {
    player: require("./player.vue").default,
  }
};